import Router from './router';
import { ToastBar, Toaster, toast } from 'react-hot-toast';

// Assets
import Cross from './assets/svgs/cross.svg';

function App() {
	return (
		<>
			<Toaster
				position='bottom-center'
				containerStyle={{
					zIndex: 9999999999,
					bottom: '110px',
					fontSize: '14px',
				}}
				toastOptions={{
					duration: 6000,
				}}
			>
				{t => (
					<ToastBar toast={t}>
						{({ message }) => (
							<>
								<div className='me-auto ms-0'>{message}</div>
								{t.type !== 'loading' && (
									<div onClick={() => toast.dismiss(t.id)}>
										<img src={Cross} alt='' />
									</div>
								)}
							</>
						)}
					</ToastBar>
				)}
			</Toaster>
			<Router />
		</>
	);
}

export default App;
